import * as yup from 'yup';

const phoneNumberRegEx = new RegExp('^4[0-9]{8}|^04[0-9]{8}');
const errorMessage = 'Please enter a valid mobile number';

export const mobileValidationSchemaWithOptional = yup.object().shape({
  mobileNumber: yup.mixed().test('mobileNumber', errorMessage, (value) => {
    if (!value || value === '') {
      return true;
    }
    return value.match(phoneNumberRegEx);
  }),
});

export const mobileValidationSchemaWithMandatory = yup.object().shape({
  mobileNumber: yup
    .string()
    .matches(phoneNumberRegEx, 'Please enter a valid mobile number')
    .required('Please enter a valid mobile number'),
});
